document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.event-tab');
  const items = document.querySelectorAll('.events-grid .grid__item');

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const filter = tab.dataset.filter;

      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      items.forEach(item => {
        const category = item.dataset.category;

        if (filter === 'ALL' || category === filter) {
          item.style.display = '';
        } else {
          item.style.display = 'none';
        }
      });
    });
  });
});